import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { SmartSearchPlanStatusTemplateComponent } from '../base-template/smart-search-plan-status-template.component';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';

@Component({
  selector: 'mbs-smart-search-restore-status-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchRestoreStatusTemplateComponent) }]
})
export class SmartSearchRestoreStatusTemplateComponent extends SmartSearchPlanStatusTemplateComponent {
  constructor(public i18nPipe: I18NextPipe) {
    super(i18nPipe);
  }
  public tag = SmartSearchTemplateName.RestoreStatus;
}
